import React from 'react';
import './styles.scss';
import classNames from 'classnames';
import Formats from 'utils/formats';
import { EnumLiteralsOf } from 'utils/types';

export const HighlightValueFormat = Object.freeze({
  CURRENCY: 'currency',
  NUMBER: 'number',
  PERCENTAGE: 'percentage'
});

export type HighlightValueFormatType = EnumLiteralsOf<typeof HighlightValueFormat>;

interface HighlightProps {
  labels: Array<string>;
  percentage?: number | string;
  value: number;
  valueFormat: HighlightValueFormatType;
}

const setFormat = (value: any, valueFormat: HighlightValueFormatType) => {
  switch (valueFormat) {
    case HighlightValueFormat.CURRENCY:
      return Formats.currency(value);
    case HighlightValueFormat.NUMBER:
      return Formats.number(value);
    case HighlightValueFormat.PERCENTAGE:
      return Formats.percentage(value, false);
    default:
      break;
  }
};

const Highlight: React.FC<HighlightProps> = ({ labels, percentage, value, valueFormat }) => {
  const tempLabels = percentage !== undefined ? labels.concat(['']) : labels;
  const percentageClass = classNames({
    percentage: true,
    positive: percentage !== undefined && percentage > 0,
    negative: percentage !== undefined && percentage < 0
  });

  const comparedPeriods = {
    YAGO: ['DOLLARS', 'UNITS'],
    PREV: ['POD', 'STORES SELLING', 'UNITS / STORES SELLING / WK', '$ OPPORTUNITY GAP']
  };

  return (
    <div className="high-light">
      <div className="value">{setFormat(value, valueFormat)}</div>
      <div className="labels-container">
        <span className="labels">{tempLabels.join(' / ')}</span>
        {percentage !== undefined && (
          <span className={percentageClass}>
            {typeof percentage === 'number' ? Formats.percentage(percentage) : percentage}
            {percentage !== '--'
              ? comparedPeriods.YAGO.indexOf(labels[0]) > -1
                ? ' YAGO'
                : ' PREV'
              : ''}
          </span>
        )}
      </div>
    </div>
  );
};

export default Highlight;
